import { render, staticRenderFns } from "./property-picker.vue?vue&type=template&id=2836fd82&scoped=true"
import script from "./property-picker.vue?vue&type=script&lang=js"
export * from "./property-picker.vue?vue&type=script&lang=js"
import style0 from "./property-picker.vue?vue&type=style&index=0&id=2836fd82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2836fd82",
  null
  
)

export default component.exports